import { PortalModel } from "@apps/mf-overview/src/server/portals/model";

import { PortalSortMethods } from "./utils/sort";

/**
 * Strucutes a base action to be used when creating action creators.
 */
export type Action<T = unknown, S = Record<string, unknown>> = {
  type: T;
} & S;

export enum PortalActionTypes {
  LOAD_PORTALS = "LoadPortals",
  LOAD_PORTALS_DONE = "LoadPortalsDone",
  LOAD_PORTALS_FAILED = "LoadPortalsFailed",
  SORT = "SortPortals",
}

type LoadPortalsAction = Action<
  PortalActionTypes.LOAD_PORTALS,
  {
    portals: Promise<PortalModel[]>;
  }
>;

export function loadPortals(
  portals: Promise<PortalModel[]>
): LoadPortalsAction {
  return {
    type: PortalActionTypes.LOAD_PORTALS,
    portals,
  };
}

type LoadPortalsDoneAction = Action<
  PortalActionTypes.LOAD_PORTALS_DONE,
  { portals: PortalModel[] }
>;

export function portalsLoaded(portals: PortalModel[]): LoadPortalsDoneAction {
  return {
    type: PortalActionTypes.LOAD_PORTALS_DONE,
    portals,
  };
}

type LoadPortalsFailedAction = Action<PortalActionTypes.LOAD_PORTALS_FAILED>;

export function portalsLoadFailed(): LoadPortalsFailedAction {
  return {
    type: PortalActionTypes.LOAD_PORTALS_FAILED,
  };
}

type SortPortalsAction = Action<
  PortalActionTypes.SORT,
  { sort: PortalSortMethods }
>;

export function sortPortals(sort: PortalSortMethods): SortPortalsAction {
  return {
    type: PortalActionTypes.SORT,
    sort,
  };
}

export type PortalActions =
  | LoadPortalsAction
  | LoadPortalsDoneAction
  | LoadPortalsFailedAction
  | SortPortalsAction;
